// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8996) return "static/chunks/8996.74167ec854967b2e.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5742 ? "9cb54ea0" : chunkId) + "-" + {"1006":"82b162016a1230c0","5742":"378b98f638223362","6489":"7f85a4e5fbe3c64e"}[chunkId] + ".js";
};